import { ISODateTimeString } from "@uppajung/hardy-har";
import { action, computed, makeObservable, observable } from "mobx";
import { isISODateTimeString } from "../../State/EvidenceDB/DatabaseTypes";

export const SecondClock = new (class SecondClock {
	private _timeSinceUnixEpoch: number = Date.now();

	setTimeSinceUnixEpoch = action ( () => {
		this._timeSinceUnixEpoch = Date.now();
	});

	@computed get now() {
		return new Date(this._timeSinceUnixEpoch);
	}

	constructor() {
		makeObservable<this, "_timeSinceUnixEpoch">(this, {_timeSinceUnixEpoch: observable});
		this._timeSinceUnixEpoch = Date.now();
		setInterval(() => this.setTimeSinceUnixEpoch(), 1000);
	}

})();


export const friendlyTimeSince = (sinceDate: Date | ISODateTimeString) => {
	const since = isISODateTimeString(sinceDate) ? new Date(sinceDate) : sinceDate;
	const {now} = SecondClock;
	const whenTodayStarted = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const daysBeforeNow = Math.floor((whenTodayStarted.getTime() - since.getTime()) / 24 * 60 * 60 * 1000);
	if (daysBeforeNow > 6) {
		return since.toLocaleString('en-US', {dateStyle: "long", timeStyle: "short"})
	}
	if (daysBeforeNow > 1) {
		return `${daysBeforeNow} days ago at ${since.toLocaleTimeString()}`;
	}
	const secondsBeforeNow = Math.floor((now.getTime() - since.getTime()) / 1000);
	const minutesBeforeNow = Math.floor(secondsBeforeNow / 60);
	const hoursBeforeNow = Math.floor(minutesBeforeNow / 60);
	if (hoursBeforeNow > 1) {
		return `${hoursBeforeNow} hours ${minutesBeforeNow % 60} minutes ago`;
	}
	if (minutesBeforeNow > 1) {
		return `${minutesBeforeNow} minutes ago`;
	}
	return `seconds ago`;
}